import React from 'react';
import { TypeAnimation } from 'react-type-animation';

const MultiLineTypingEffect = () => {
    const multiLine = [
        "Hello Krishan",
        "How are you today...."
    ]
  return (
    <TypeAnimation
    cursor={false}
      sequence={[
        [...multiLine].join("\n")
      ]}
      wrapper="div"
      speed={50}
      omitDeletionAnimation={true}
      style={{ fontSize: '2em', whiteSpace: 'pre-line' }}
      repeat={0}  // Ensures the animation runs only once
    />
  );
};

export default MultiLineTypingEffect;
